var _style, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIconMachines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29,
    width: 3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 29,
    width: 3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 29,
    width: 3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 29,
    width: 3,
    height: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "15.1,8.1 15.1,18.901 17,18.901 18,21 19,21 19,25.469 19.5,26 20,25.469 20,21 21,21 22,18.901 23.9,18.901  23.9,8.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1,13.1v5h-3v8.802h3v3.765l5.234,5.234h22.332l5.234-5.234V13.1H3.1z M0.9,26.101v-7.2h5.2v7.2H0.9z M35.1,30.334 L30.334,35.1H8.666L3.9,30.334v-3.433h3V18.1h-3v-4.199h31.2V30.334z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 45,
    height: 45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIconMachines);
export default __webpack_public_path__ + "static/media/header-icon-machines.cbd8052e5774860a9d8238726d687c90.svg";
export { ForwardRef as ReactComponent };